import { render, staticRenderFns } from "./BooksellerActiveStatus.vue?vue&type=template&id=788ad75e&scoped=true&"
import script from "./BooksellerActiveStatus.vue?vue&type=script&lang=js&"
export * from "./BooksellerActiveStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788ad75e",
  null
  
)

export default component.exports